import React from "react";
import './Register.css';

function Register()
{
    return(
            <>
            <div className="bg-body-tertiary min-vh-100XXX d-flex flex-row align-items-center">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card mb-4 mx-4">
              <div className="card-body p-4">
                <h1>Register</h1>
                <p className="text-body-secondary">Create your account</p>
                <div className="input-group mb-3">
                    {/* <span className="input-group-text">
                    <svg className="icon">
                      <use xlink:href="vendors/@coreui/icons/svg/free.svg#cil-user"></use>

                    </svg></span> */}
                  <input className="form-control" type="text" placeholder="Username"/>
                </div>
                <div className="input-group mb-3">
                    {/* <span className="input-group-text">
                    <svg className="icon">
                      <use xlink:href="vendors/@coreui/icons/svg/free.svg#cil-envelope-open"></use>
                    </svg></span> */}
                  <input className="form-control" type="text" placeholder="Email"/>
                </div>
                <div className="input-group mb-3">
                    {/* <span className="input-group-text">
                    <svg className="icon">
                      <use xlink:href="vendors/@coreui/icons/svg/free.svg#cil-lock-locked"></use>
                    </svg></span> */}
                  <input className="form-control" type="password" placeholder="Password"/>
                </div>
                <div className="input-group mb-4">
                    {/* <span className="input-group-text">
                    <svg className="icon">
                      <use xlink:href="vendors/@coreui/icons/svg/free.svg#cil-lock-locked"></use>
                    </svg></span> */}
                  <input className="form-control" type="password" placeholder="Repeat password"/>
                </div>
                <button className="btn btn-block btn-success" type="button">Create Account</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
                    </>
    );
}
export default Register;